import type { BoxProps } from '@mui/material/Box';
import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

type PageContainerProps = BoxProps & {
  children: ReactNode;
};

export const PageContainer = ({ children, sx, ...props }: PageContainerProps) => {
  return (
    <Box
      sx={{
        ml: { xs: 0, lg: '70px' },
        width: { lg: 'calc(100% - 70px)', xs: '100%' },
        p: { xs: '0 20px 10px 20px', md: '0 30px 16px 30px' },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const SubNavPageContainer = ({ children, sx, ...props }: PageContainerProps) => {
  return (
    <Box
      sx={{
        ml: { xs: 0, lg: '315px' },
        width: { lg: 'calc(100% - 315px)', xs: '100%' },
        p: { xs: '0 20px 20px', md: '0 30px 30px' },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
